export default "__VITE_ASSET__BEJEBNXa__"